import { useState } from "react";

export function useShareHook(shareData: ShareData) {
  const canShare = navigator && navigator.canShare && navigator.canShare(shareData);

  async function toggleShare() {
    if(canShare){
      try {
        await navigator.share(shareData);
      } catch (error) {}
    }
  }

  return { toggleShare, canShare };
}
